import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/PhilHome.vue'
import Login from '../components/PhilLogin.vue'
import MemberLogin from '../components/MemberLogin.vue'
import OptionsLogin from '../components/OptionsLogin.vue'
import InputNumber from '../components/InputCertNumber.vue'
import MemberPage from '../components/MemberPage.vue'
import Status from '../components/Status.vue'
import HistoryPage from '../components/History.vue'
import FindADoctor from '../components/FindADoctor.vue'
import DoctorName from '../components/ByName.vue'
import LOAConsultation from '../components/LoaConsultation.vue'
import PersonalInfo from '../components/PersonalInfo.vue'
import Birthdate from '../components/Birthdate.vue'
import LoaPage2 from '../components/LoaPage2.vue'
import LoaLab from '../components/LoaLab.vue'
import LoaLab2 from '../components/LoaLab2.vue'
import LoaLab3 from '../components/LoaLab3.vue'
import LoaPage3 from '../components/LoaPage3.vue'
import LoaPage4 from '../components/LoaPage4.vue'
import LoaPage5 from '../components/LoaPage5.vue'
import LoaPage6 from '../components/LoaPage6.vue'
import LoaCons2 from '../components/LoaCons2.vue'
import LoaCons3 from '../components/LoaCons3.vue'
import LoaCons4 from '../components/LoaCons4.vue'
import LoaCons5 from '../components/LoaCons5.vue'
import LoaCons6 from '../components/LoaCons6.vue'
import LoaPreview from '../components/LoaPreview.vue'
import LoaLab4 from '../components/LoaLab4.vue'
import LoaLab5 from '../components/LoaLab5.vue'
import CustomerAdvocate from '../components/CustomerAdvocate.vue'
import CustomerAdvocate2 from '../components/CustomerAdvocate2.vue'
import Specialization from '../components/BySpecialization.vue'
import CertTest from '../components/CertTest.vue'
import CustomerAdvocate3 from '../components/CustomerAdvocate3.vue'
import CustomerNonMember from '../components/CustomerNonMember.vue'
import TapNFC from '../components/TapNFC.vue'
import Form from '../components/Form.vue'
import Shop from '../components/Shop.vue'
import Keyboard from '../components/Keyboard.vue'
import LoaPreviewV2 from '../components/LoaPreviewV2.vue'
import HeyPhilVideo from '../components/HeyPhilVideo.vue'
import FindAProvider from '../components/FindAProvider.vue'
//import FindAProviderLocation from '../components/FindAProviderLocation.vue'





Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/member-login',
    name: 'Member-Login',
    component: MemberLogin
  },
  {
    path: '/options-login',
    name: 'Options-Login',
    component: OptionsLogin
  },
  {
    path: '/input-number',
    name: 'Input-Number',
    component: InputNumber
  },
  {
    path: '/member-page',
    name: 'Member-Page',
    component: MemberPage
  },
  {
    path: '/status',
    name: 'Status',
    component: Status
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage
  },
  {
    path: '/find-a-doctor',
    name: 'FindADoctor',
    component: FindADoctor
  },
  {
    path: '/by-name',
    name: 'DoctorName',
    component: DoctorName
  },
  {
    path: '/by-specialization',
    name: 'Specialization',
    component: Specialization
  },
  {
    path: '/loa-consultation',
    name: 'LOAConsultation',
    component: LOAConsultation,
    meta: { requiresConsult: true }
  },
  {
    path: '/personal-info',
    name: 'PersonalInfo',
    component: PersonalInfo
  },
  {
    path: '/birth-date',
    name: 'Birthdate',
    component: Birthdate
  },
  {
    path: '/loa-page-2',
    name: 'LoaPage2',
    component: LoaPage2
  },
  {
    path: '/loa-lab',
    name: 'LoaLab',
    component: LoaLab,
    meta: { requiresLab: true }
  },
  {
    path: '/loa-lab-2',
    name: 'LoaLab2',
    component: LoaLab2
  },
  {
    path: '/loa-lab-3',
    name: 'LoaLab3',
    component: LoaLab3
  },
  {
    path: '/loa-page-3',
    name: 'LoaPage3',
    component: LoaPage3
  },
  {
    path: '/loa-page-4',
    name: 'LoaPage4',
    component: LoaPage4
  },
  {
    path: '/loa-page-5',
    name: 'LoaPage5',
    component: LoaPage5
  },
  {
    path: '/loa-page-6',
    name: 'LoaPage6',
    component: LoaPage6
  },
  {
    path: '/loa-cons-2',
    name: 'LoaCons2',
    component: LoaCons2
  },
  {
    path: '/loa-cons-3',
    name: 'LoaCons3',
    component: LoaCons3
  },
  {
    path: '/loa-cons-4',
    name: 'LoaCons4',
    component: LoaCons4
  },
  {
    path: '/loa-cons-5',
    name: 'LoaCons5',
    component: LoaCons5
  },
  {
    path: '/loa-cons-6',
    name: 'LoaCons6',
    component: LoaCons6
  },
  {
    path: '/loa-preview',
    name: 'LoaPreview',
    component: LoaPreview
  },
  {
    path: '/loa-lab-4',
    name: 'LoaLab4',
    component: LoaLab4
  },
  {
    path: '/loa-lab-5',
    name: 'LoaLab5',
    component: LoaLab5
  },
  {
    path: '/customer-advocate',
    name: 'CustomerAdvocate',
    component: CustomerAdvocate
  },
  {
    path: '/customer-advocate-2',
    name: 'CustomerAdvocate2',
    component: CustomerAdvocate2
  },
  {
    path: '/cert-test',
    name: 'CertTest',
    component: CertTest
  },
  {
    path: '/customer-advocate-3',
    name: 'CustomerAdvocate3',
    component: CustomerAdvocate3
  },
  {
    path: '/customer-non-member',
    name: 'CustomerNonMember',
    component: CustomerNonMember
  },
  {
    path: '/tap-nfc-card',
    name: 'TapNFC',
    component: TapNFC
  },
  {
    path: '/form',
    name: 'Form',
    component: Form
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/keyboard',
    name: 'Keyboard',
    component: Keyboard
  },
  {
    path: '/loa-prev',
    name: 'Loa Preview V2',
    component: LoaPreviewV2
  },
  {
    path: '/hey-phil',
    name: 'Hey Phil Video',
    component: HeyPhilVideo
  },

  {
    path: '/find-a-provider',
    name: 'Provider',
    component: FindAProvider
  },

/*  {
    path: '/find-a-provider-location',
    name: 'ProviderLocation',
    component: FindAProviderLocation
  } */
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const needsConsult = to.matched.some(r => r.meta.requiresConsult)
  const needsLab = to.matched.some(r => r.meta.requiresLab)

  if (needsConsult || needsLab) {
    if (localStorage.getItem('CertNo') === null) {
      return next('/login')
    }
    if (needsConsult && localStorage.getItem('allowLOAConsult') !== '1') {
      return next('/member-page')
    }
    if (needsLab && localStorage.getItem('allowLOALab') !== '1') {
      return next('/member-page')
    }
  }
  next()
})

export default router
